import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { default as toWebVTT } from "srt-webvtt";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, Checkbox, Divider, FormHelperText } from "@mui/material";
import Typography from "@mui/material/Typography";
import TheatersIcon from "@mui/icons-material/Theaters";
import DraggableComponent from "./DraggableComponent";

import { selectSubtitleOneSchema } from "../../validations/selectVideoAndSubValidation";
import { useContext } from "react";
import MainContext from "../../context/mainContext";
import srtParser2 from "srt-parser-2";
import { getSubtitlesApi } from "../../services/subtitlesApi";
import { getDetalisListOfUserWordsApi } from "../../services/userSaveWordApi";
import {
  getWordLearningListByLangApi,
  getReadyWordLearningListByLangApi,
} from "../../services/leitnerApi";
import { getWordsByCefrLevelApi } from "../../services/cefrWordsApi";
import { customToastify } from "../pages/utils/utilsFunctions";

const getDifficultyWordLevel = (num) => {
  num++;
  let factor = 15;
  let level = Math.ceil(Math.sqrt(num / factor));
  if (level > 9) level = 9;
  return level;
};
export default function SelectSubtitles(props) {
  const {
    handleSubtitleTwoDisable,
    subtitleTwoDisable,
    selectSubtitlesBox,
    handleCloseSelectSubtitlesBox,
    fullscreenState,
    handleFullscreenState,
    handleFullScreen,
    searchSubtitlesBoxData,
    handleSearchSubtitlesBoxOpen,
    handleMainCompareSubsOpen,
    handleCompareSubtitlesData,
    compareSubtitlesBoxData,
    handleActiveSubtitleOneId,
    handleActiveSubtitleTwoId
  } = props;
  const {
    handleVideoInfo,
    videoInfo,
    subtitleStylesData,
    handleSubtitleContenet,
    userWords,
    handleUserWords,
    handleUserWordsDifficultyLevel,
    subWordLearningStyles,
    subWordCEFRStyles,
    cferWordsLevel,
    handleCferWordsLevel,
    userTypes,
    handleOpenSignInBox,
    handleAllSubtitle,
  } = useContext(MainContext);
  const [hiddenSubs, setHiddenSubs] = useState([]);
  const [subtitleOneLanguage, setSubtitleOneLanguage] = React.useState("");
  const [oldLangOne, setOldLangOne] = React.useState("");
  const [errorSuffix, setErrorSuffix] = React.useState(false);
  const [oldLangTwo, setOldLangTwo] = React.useState("");
  const [subtitleOneFileName, setSubtitleOneFileName] = React.useState({
    searchBox: false,
    filename: "",
  });
  const [subtitleTwoLanguage, setSubtitleTwoLanguage] = React.useState("");
  const [subtitleTwoFileName, setSubtitleTwoFileName] = React.useState({
    searchBox: false,
    filename: "",
  });
  const [subtitleSearchBox, setSubtitleSearchBox] = React.useState(false);
  const [selectedSubtitle, setSelectedSubtitle] = React.useState("");
  const [subOneId, setSubOneId] = React.useState("");
  const [subTwoId, setSubTwoId] = React.useState("");

  useEffect(() => {
    setSubtitleOneLanguage("en");
    setSubtitleTwoLanguage("fa");
    if (selectSubtitlesBox["reset"]) {
      setSubtitleOneLanguage("");
      setSubtitleTwoLanguage("");
      setSubtitleOneFileName({ searchBox: false, filename: "" });
      setSubtitleTwoFileName({ searchBox: false, filename: "" });
    }
  }, []);

  useEffect(() => {
    if (
      searchSubtitlesBoxData["dataChange"] &&
      searchSubtitlesBoxData["subtitlesUploadId"]
    ) {
      if (searchSubtitlesBoxData["subNumber"] == "one") {
        setSubOneId(searchSubtitlesBoxData["subtitlesUploadId"]);
        setSubtitleOneFileName({ searchBox: false, filename: "" });
      } else {
        setSubTwoId(searchSubtitlesBoxData["subtitlesUploadId"]);
        setSubtitleTwoFileName({ searchBox: false, filename: "" });
      }
      handleToggleSearchBox(
        searchSubtitlesBoxData["formProps"],
        searchSubtitlesBoxData["subtitlesUploadId"],
        searchSubtitlesBoxData["subNumber"]
      );
    }
  }, [searchSubtitlesBoxData]);

  // const getHiddensInfo = () => {
  //   let hiddenSubsInfo = [];
  //   subtitleStylesData.forEach((element) => {
  //     if (element["hidden"] == true) hiddenSubsInfo.push(element["key"]);
  //   });
  //   setHiddenSubs(hiddenSubsInfo);
  // };

  const getCEFRLevel = (level) => {
    if (level == 1) return "a1";
    else if (level == 2) return "a2";
    else if (level == 3) return "b1";
    else if (level == 4) return "b2";
    else if (level == 5) return "c1";
    else if (level == 6) return "c2";
    else return false;
  };

  const getAllwordsByCFERLevel = async (lang, level) => {
    try {
      if (cferWordsLevel["levels"].indexOf(level) >= 0) {
      } else {
        let response = await getWordsByCefrLevelApi({
          lang,
          level: getCEFRLevel(level),
        });
        if (response && response["data"]) {
          let newlevels = Array(response["data"].length).fill(level);
          let cp = { ...cferWordsLevel };
          cp["words"].push(...response["data"]);
          cp["levels"].push(...newlevels);
          handleCferWordsLevel(cp);
        } else {
          console.log("error in get CFER Words");
        }
      }
    } catch (error) {
      console.log("getAllwordsByCFERLevel", error);
    }
  };

  const getAllwordsByCFER = async () => {
    try {
      const language = videoInfo["subtitleOneLanguage"];
      if (language == "en") {
        for (let lvl = 1; lvl < 7; lvl++) {
          let checkSate =
            subWordCEFRStyles[`bk_on_${lvl}`] ||
            subWordCEFRStyles[`co_on_${lvl}`] ||
            subWordCEFRStyles[`rp_${lvl}`] !== 0 ||
            subWordCEFRStyles[`ps_${lvl}`] !== 0;
          if (checkSate) await getAllwordsByCFERLevel(language, lvl);
        }
      }
    } catch (error) {
      console.log("getAllwordsByCFER", error);
    }
  };

  const checkWordLearningListByLangState = () => {
    try {
      let chceck = false;
      for (let lvl = 1; lvl < 10; lvl++) {
        if (
          subWordLearningStyles[`co_on_${lvl}`] ||
          subWordLearningStyles[`bk_on_${lvl}`] ||
          subWordLearningStyles[`rp_${lvl}`] !== 0 ||
          subWordLearningStyles[`ps_${lvl}`] !== 0
        )
          chceck = true;
        if (chceck) break;
      }
      return chceck;
    } catch (error) {
      console.log("checkWordLearningListByLangState", error);
      return false;
    }
  };

  const checkReadyWordLearningListByLangState = () => {
    try {
      let chceck = false;
      if (
        subWordLearningStyles[`co_on_10`] ||
        subWordLearningStyles[`bk_on_10`] ||
        subWordLearningStyles[`rp_10`] !== 0 ||
        subWordLearningStyles[`ps_10`] !== 0
      )
        chceck = true;
      return chceck;
    } catch (error) {
      console.log("checkReadyWordLearningListByLangState", error);
      return false;
    }
  };

  const subtitleTwoControl = (subtitileTwoJson, langTwo) => {
    handleAllSubtitle("Two", subtitileTwoJson);
    handleSubtitleContenet("Two", "");
    if (subtitileTwoJson.length == 0){
      handleActiveSubtitleTwoId(false)
      return false;
    } 
    let trackTwo = document.querySelector("#subtitlesTwoTrack");
    trackTwo.addEventListener("cuechange", function (e) {
      if (e.target.track.activeCues.length !== 0) {
        // console.log("subtitileTwoJson----------", subtitileTwoJson[(e.target.track.activeCues[0].id) - 1].text)
        handleActiveSubtitleTwoId(e.target.track.activeCues[0].id)
        handleSubtitleContenet(
          "Two",
          subtitileTwoJson[e.target.track.activeCues[0].id - 1].text
        );
        // document.getElementById("SubtitleTwoContent").innerHTML = splitToWords(textToSimple(subtitileTwoJson[(e.target.track.activeCues[0].id) - 1].text), "hover-subtitlee-two")
      } else {
        handleSubtitleContenet("Two", "");
        // document.getElementById("SubtitleTwoContent").innerText = ""
      }
    });

    // کد زیر برای قسمتی که میخواهیم ترجمه لغت را استفاده کنیم باید گذاشته شود
    // document.body.addEventListener("mouseenter", function (e) {
    //     if (e.target.className === "hover-subtitlee-two") {
    //         console.log("catched", e.target.innerText);
    //     }
    // }, true)
  };

  const subtitleOneControl = (subtitileOneJson, langOne) => {
    handleAllSubtitle("One", subtitileOneJson);
    handleSubtitleContenet("One", "");
    if (subtitileOneJson.length == 0) {
      handleActiveSubtitleOneId(false);
      return false;
    }
    let trackOne = document.querySelector("#subtitlesOneTrack");
    // trackOne.removeEventListener("cuechange", (e)=>{console.log(e)});
    trackOne.addEventListener("cuechange", function (e) {
      // handleRpPsvideoPlayer({psPlayer: 5})
      if (e.target.track.activeCues.length !== 0) {
        handleActiveSubtitleOneId(e.target.track.activeCues[0].id);
        handleSubtitleContenet(
          "One",
          subtitileOneJson[e.target.track.activeCues[0].id - 1].text
        );
        // console.log("for get time",subtitileOneJson[(e.target.track.activeCues[0].id) - 1])

        // document.getElementById("SubtitleOneContent").innerHTML = splitToWords(textToSimple(subtitileOneJson[(e.target.track.activeCues[0].id) - 1].text), "hover-subtitlee-one")
      } else {
        handleSubtitleContenet("One", "");
        // document.getElementById("SubtitleOneContent").innerText = ""
      }
    });

    // کد زیر برای قسمتی که میخواهیم ترجمه لغت را استفاده کنیم باید گذاشته شود
    // document.body.addEventListener("mouseenter", function (e) {
    //     if (e.target.className === "hover-subtitlee-one") {
    //         console.log("createElement",e.target.innerText)
    //     }
    // }, true)
  };

  const rtlLanguages = ["fa", "ar"];

  const handleToggleSearchBox = async (props, subId, subNumber) => {
    try {
      let response = await getSubtitlesApi({ subtitlesUploadId: subId });
      let subFile = new File([response.data], "fileName");
      if (subNumber == "one") props.setFieldValue("subtitleOneFile", subFile);
      else if (subNumber == "two") {
        props.setFieldValue("subtitleTwoFile", subFile);
      } else console.log("error find subtitle");
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubtitleFileName = (number, searchBox, data) => {
    if (number == "one") {
      if (!searchBox)
        setSubtitleOneFileName({ searchBox: false, filename: data.name });
      else setSubtitleOneFileName({ searchBox: true, filename: data.name });
    } else if (number == "two") {
      if (!searchBox)
        setSubtitleTwoFileName({ searchBox: false, filename: data.name });
      else setSubtitleTwoFileName({ searchBox: true, filename: data.name });
    }
  };
  const handleCloseButton = () => {
    handleCloseSelectSubtitlesBox();
    setSubtitleOneLanguage(videoInfo.subtitleOneLanguage || "");
    setSubtitleTwoLanguage(videoInfo.subtitleTwoLanguage || "");
    setSubtitleOneFileName({ searchBox: false, filename: "" });
    setSubtitleTwoFileName({ searchBox: false, filename: "" });
  };
  const initialValues = {
    subtitleOneLanguage: videoInfo.subtitleOneLanguage || "",
    subtitleOneFile: videoInfo.subtitleOneFile || "",
    subtitleTwoLanguage: videoInfo.subtitleTwoLanguage || "",
    subtitleTwoFile: videoInfo.subtitleTwoFile || "",
    subtitleTwoOff: videoInfo.subtitleTwoOff || false,
  };

  const onSubmit = (values, props) => {
    let newValues = {
      subtitleOneLanguage: values.subtitleOneLanguage,
      subtitleOneFile: values.subtitleOneFile,
      subtitleOneRtl: rtlLanguages.includes(values.subtitleOneLanguage),
      subtitleTwoLanguage: values.subtitleTwoLanguage,
      subtitleTwoFile: values.subtitleTwoFile,
      subtitleTwoRtl: rtlLanguages.includes(values.subtitleTwoLanguage),
      subtitleTwoOff: values.subtitleTwoOff,
    };
    if (values.subtitleTwoOff == true) newValues.subtitleTwoFile = "";
    handleVideoInfo({
      ...videoInfo,
      ...newValues,
    });
    handleCloseSelectSubtitlesBox();
    const subOneFile = values["subtitleOneFile"];
    const subOneLang = values["subtitleOneLanguage"];
    const subOneName = subtitleOneFileName.searchBox
      ? subtitleOneFileName.filename
      : false;
    const subTwoFile = values["subtitleTwoFile"];
    const subTwoLang = values["subtitleTwoLanguage"];
    const subTwoName = subtitleTwoFileName.searchBox
      ? subtitleTwoFileName.filename
      : false;
    if (subOneFile && subTwoFile) {
      addTrackToVideo(
        subOneFile,
        subOneLang,
        subOneName,
        subTwoFile,
        subTwoLang,
        subTwoName
      );
    } else if (subOneFile) {
      addTrackToVideo(
        subOneFile,
        subOneLang,
        subOneName,
        "",
        subTwoLang,
        false
      );
    }
    setSubtitleOneFileName({ searchBox: false, filename: "" });
    setSubtitleTwoFileName({ searchBox: false, filename: "" });
    if (fullscreenState && !handleFullScreen.active) {
      handleFullScreen.enter();
    }
    setErrorSuffix(false);
  };

  const srtToJson = (file, lang, number) => {
    //    let newfile
    //    await fetch('http://localhost:4009/subtitles/new.srt')
    //   .then(res => res.blob()) // Gets the response and returns it as a blob
    //   .then(blob => {
    //     console.log("fetch",blob)
    //     newfile=blob
    //     // Here's where you get access to the blob
    //     // And you can use it for whatever you want
    //     // Like calling ref().put(blob)
    //     // Here, I use it to make an image appear on the page
    //     let objectURL = URL.createObjectURL(blob);
    // });
    // let token = JSON.parse(localStorage.getItem("token"));
    // const config = { responseType: 'blob',headers: {
    //   Accept: "Application/json",
    //   authorization: `bearer ${token}`,
    // } };
    // axios.post('http://localhost:4009/subtitles/api/v1/subtitles/getSubtitles',{}, {
    //   responseType: "blob",
    //   headers: {Accept: "Application/json",authorization: `bearer ${token}`}
    // }).then(response => {
    //   console.log("axios",response["data"])
    //     let nwww=new File([response.data], "fileName");
    //   console.log("axiosnwww",nwww)

    // });
    // reader.readAsText(newfile);
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const text = reader.result;
      let parser = new srtParser2();
      let result = parser.fromSrt(text);
      if (number == "one") subtitleOneControl(result, lang);
      if (number == "two") subtitleTwoControl(result, lang);
    };
  };

  const adjustInitialTimeShift = (subNumber, time) => {
    if (time !== 0) {
      const video = document.querySelector("video");
      if (video) {
        let textTracks =
          subNumber == 1 ? video.textTracks[0] : video.textTracks[1];
        if (textTracks)
          Array.from(textTracks.cues).forEach((cue) => {
            cue.startTime += time;
            cue.endTime += time;
          });
      }
    }
  };

  const addTrackToVideo = async (
    subtitleOneFile,
    langOne,
    searchOne,
    subtitleTwoFile,
    langTwo,
    searchTwo
  ) => {
    try {
      let video = document.querySelector("#MainVideo video");
      if (subtitleOneFile) {
        let subtitleOne;
        if (searchOne) {
          let data = { fileName: `${searchOne}` };
          let text = await getSubtitlesApi(data);
          let file = new File([text.data], "subtitleOne.srt");
          subtitleOne = file;
        } else subtitleOne = subtitleOneFile;

        const textTrackUrl1 = await toWebVTT(subtitleOne);
        let oldTrack1 = document.getElementById("subtitlesOneTrack");
        if (oldTrack1) video.removeChild(oldTrack1);
        let track1 = document.createElement("track");
        track1.kind = "subtitles";
        track1.id = "subtitlesOneTrack";
        track1.src = textTrackUrl1;
        track1.srclang = langOne;
        video.appendChild(track1);
        srtToJson(subtitleOne, langOne, "one");
      }
      if (subtitleTwoFile) {
        let subtitleTwo;
        if (searchTwo) {
          let data = { fileName: `${searchOne}` };
          let text = await getSubtitlesApi(data);
          let file = new File([text.data], "subtitleTwo.srt");
          subtitleTwo = file;
        } else subtitleTwo = subtitleTwoFile;

        const textTrackUrl2 = await toWebVTT(subtitleTwo);
        let oldTrack2 = document.getElementById("subtitlesTwoTrack");
        if (oldTrack2) video.removeChild(oldTrack2);
        let track2 = document.createElement("track");
        track2.kind = "subtitles";
        track2.id = "subtitlesTwoTrack";
        track2.src = textTrackUrl2;
        track2.srclang = langOne;
        video.appendChild(track2);
        srtToJson(subtitleTwo, langTwo, "two");
      } else {
        let oldTrack2 = document.getElementById("subtitlesTwoTrack");
        if (oldTrack2) {
          video.removeChild(oldTrack2);
          subtitleTwoControl([], langTwo);
        }
      }
      if (video["textTracks"]) {
        for (let i = 0; i < video["textTracks"].length; i++) {
          video.textTracks[i].mode = "hidden";
        }
      }
      if (oldLangOne !== langOne || oldLangTwo !== langTwo) {
        setOldLangOne(langOne);
        setOldLangTwo(langTwo);
        let userSavedWords = [];
        let AllUserWordslearningLevel = { words: [], levels: [] };
        if (userTypes.includes("user")) {
          let remainSavedWords = true;
          let pageNum = 1;
          while (remainSavedWords) {
            const getUserSavedWords = await getDetalisListOfUserWordsApi(
              { fromLang: langOne, toLang: langTwo },
              { page: pageNum, perPage: 50 }
            );
            if (
              getUserSavedWords["data"] &&
              getUserSavedWords["data"]["success"]
            ) {
              getUserSavedWords["data"]["data"]["docs"].forEach((element) => {
                userSavedWords.push(element["word"].toLowerCase());
              });
              if (getUserSavedWords["data"]["data"]["hasNextPage"]) pageNum++;
              else remainSavedWords = false;
            } else {
              remainSavedWords = false;
            }
          }
        }
        // const getLeitnerWords=await getDetalisListOfUserWordsApi({fromLang:langOne,toLang:langTwo},{page:1,perPage:50})

        // زمان گرفتن لغات ذخیره شده از کاربر و لایتنر
        let userLeitnerlearningLevel1 = [];
        let userLeitnerlearningLevel2 = [];
        let userLeitnerlearningLevel3 = [];
        let userLeitnerlearningLevel4 = [];
        let userLeitnerlearningLevel5 = [];
        let userLeitnerlearningLevel6 = [];
        let userLeitnerlearningLevel7 = [];
        let userLeitnerlearningLevel8 = [];
        let userLeitnerlearningLevel9 = [];
        if (userTypes.includes("user")) {
          let getWordLearningListByLangState =
            checkWordLearningListByLangState();
          if (getWordLearningListByLangState) {
            let remainWordLearning = true;
            let pageNum = 1;
            while (remainWordLearning) {
              const getWordLearningListByLang =
                await getWordLearningListByLangApi(
                  {
                    fromLang: langOne,
                    toLang: langTwo,
                  },
                  { page: pageNum, perPage: 50 }
                );
              if (
                getWordLearningListByLang["data"] &&
                getWordLearningListByLang["data"]["success"]
              ) {
                getWordLearningListByLang["data"]["data"]["docs"].forEach(
                  (element) => {
                    if (element["learningLevel"] == 1) {
                      userLeitnerlearningLevel1.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 2) {
                      userLeitnerlearningLevel2.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 3) {
                      userLeitnerlearningLevel3.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 4) {
                      userLeitnerlearningLevel4.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 5) {
                      userLeitnerlearningLevel5.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 6) {
                      userLeitnerlearningLevel6.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 7) {
                      userLeitnerlearningLevel7.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 8) {
                      userLeitnerlearningLevel8.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                    if (element["learningLevel"] == 9) {
                      userLeitnerlearningLevel9.push({
                        card: element["frontCard"],
                        allLearningTimes: element["allLearningTimes"],
                      });
                      AllUserWordslearningLevel["words"].push(
                        element["frontCard"].toLowerCase()
                      );
                      AllUserWordslearningLevel["levels"].push(
                        getDifficultyWordLevel(element["allLearningTimes"])
                      );
                    }
                  }
                );
                if (getWordLearningListByLang["data"]["data"]["hasNextPage"])
                  pageNum++;
                else remainWordLearning = false;
              } else {
                remainWordLearning = false;
              }
            }
          }
          let getReadyWordLearningListByLangState =
            checkReadyWordLearningListByLangState();
          if (getReadyWordLearningListByLangState) {
            let remainReadyWordLearning = true;
            let pageNum = 1;
            while (remainReadyWordLearning) {
              const getReadyWordLearningListByLang =
                await getReadyWordLearningListByLangApi(
                  {
                    fromLang: langOne,
                    toLang: langTwo,
                  },
                  { page: pageNum, perPage: 50 }
                );
              if (
                getReadyWordLearningListByLang["data"] &&
                getReadyWordLearningListByLang["data"]["success"]
              ) {
                getReadyWordLearningListByLang["data"]["data"]["docs"].forEach(
                  (element) => {
                    AllUserWordslearningLevel["words"].push(
                      element["frontCard"].toLowerCase()
                    );
                    AllUserWordslearningLevel["levels"].push(10);
                  }
                );
                if (
                  getReadyWordLearningListByLang["data"]["data"]["hasNextPage"]
                )
                  pageNum++;
                else remainReadyWordLearning = false;
              } else {
                remainReadyWordLearning = false;
              }
            }
          }
        }
        const userWords = {
          userSavedWords,
          userLeitnerlearningLevel1,
          userLeitnerlearningLevel2,
          userLeitnerlearningLevel3,
          userLeitnerlearningLevel4,
          userLeitnerlearningLevel5,
          userLeitnerlearningLevel6,
          userLeitnerlearningLevel7,
          userLeitnerlearningLevel8,
          userLeitnerlearningLevel9,
        };
        handleUserWords(userWords);
        handleUserWordsDifficultyLevel(AllUserWordslearningLevel);
        getAllwordsByCFER();
      }
      if (compareSubtitlesBoxData["subOne"]["timeShift"]) {
        setTimeout(() => {
          adjustInitialTimeShift(
            1,
            compareSubtitlesBoxData["subOne"]["timeShift"]
          );
        }, 1000);
      }
      if (compareSubtitlesBoxData["subTwo"]["timeShift"]) {
        setTimeout(() => {
          adjustInitialTimeShift(
            2,
            compareSubtitlesBoxData["subTwo"]["timeShift"]
          );
        }, 2000);
      }
      handleCompareSubtitlesData({
        newData: false,
        subOne: false,
        subTwo: false,
      });
    } catch (error) {
      console.log("Error in addTrackToVideo", error);
    }
  };

  const handlePushCaompareSub = (formProps, data) => {
    if (data["subOne"]) {
      if (data["subOne"]["type"] == "id") {
        setSubOneId(data["subOne"]["content"]);
        setSubtitleOneFileName({ searchBox: false, filename: "" });
        handleToggleSearchBox(formProps, data["subOne"]["content"], "one");
      } else {
        formProps.setFieldValue("subtitleOneFile", data["subOne"]["content"]);
        handleSubtitleFileName("one", false, data["subOne"]["content"]);
        setSubOneId("");
      }
    }
    if (data["subTwo"]) {
      if (data["subTwo"]["type"] == "id") {
        setSubTwoId(data["subTwo"]["content"]);
        setSubtitleTwoFileName({ searchBox: false, filename: "" });
        handleToggleSearchBox(formProps, data["subTwo"]["content"], "two");
      } else {
        formProps.setFieldValue("subtitleTwoFile", data["subTwo"]["content"]);
        handleSubtitleFileName("two", false, data["subTwo"]["content"]);
        setSubTwoId("");
      }
    } else {
      formProps.setFieldValue("subtitleTwoFile", "");
    }
    handleCompareSubtitlesData({ newData: false });
  };

  // const handleChange = (e) => {setAge(e.target.value);props.setFieldValue("subtitleOneLanguage", e.target.value)};

  return (
    // <React.Fragment >
    //   <Dialog
    //     open={selectSubtitlesBox["open"]}
    //   >
    //     <DialogContent sx={{ ml: 0, pl: 0 }}  id="amir123456">
    <Formik
      initialValues={initialValues}
      validationSchema={selectSubtitleOneSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <DraggableComponent maxWidth={"100%"}>
          <Paper
            sx={{
              display: selectSubtitlesBox["open"]
                ? "block !important"
                : "none !important",
              width: "100%",
              position: "relative",
              textAlign: "justify",
              borderRadius: "10px",
              p: 1,
            }}
          >
            <Form>
              <Typography
                sx={{
                  color: "red",
                  textAlign: "center",
                  display: errorSuffix ? "block" : "none",
                }}
              >
                {errorSuffix == "zip"
                  ? "*خطا: لطفا ابتدا فایل زیرنویس را از حالت فشرده(zip) خارج کنید*"
                  : "*خطا: لطفا فایل با پسوند srt انتخاب کنید*"}
              </Typography>
              <Divider sx={{ textAlign: "center" }}>زبان زیرنویس ها</Divider>
              <Box>
                {compareSubtitlesBoxData["newData"] ? (
                  <>
                    <Typography>زیرنویس انتخاب شده اول:</Typography>
                    {compareSubtitlesBoxData["subOne"]["type"] ? (
                      <Typography>
                        {compareSubtitlesBoxData["subOne"]["type"] == "id"
                          ? compareSubtitlesBoxData["subOne"]["content"]
                          : compareSubtitlesBoxData["subOne"]["content"][
                              "name"
                            ]}
                      </Typography>
                    ) : (
                      <Typography>-------------</Typography>
                    )}
                    <Typography>زیرنویس انتخاب شده دوم:</Typography>
                    {compareSubtitlesBoxData["subTwo"]["type"] ? (
                      <Typography>
                        {compareSubtitlesBoxData["subTwo"]["type"] == "id"
                          ? compareSubtitlesBoxData["subTwo"]["content"]
                          : compareSubtitlesBoxData["subTwo"]["content"][
                              "name"
                            ]}
                      </Typography>
                    ) : (
                      <Typography>-------------</Typography>
                    )}

                    <Button
                      color="info"
                      variant="contained"
                      onClick={() => {
                        handlePushCaompareSub(props, compareSubtitlesBoxData);
                      }}
                    >
                      ادامه
                    </Button>
                  </>
                ) : (
                  <>
                    <Box sx={{ display: "flex" }}>
                      <Tooltip
                        title={`${
                          subtitleStylesData["sub1_hidden"] ? "پنهان" : "نمایش"
                        } (ویرایش در بخش تنظیمات زیرنویس)`}
                      >
                        {subtitleStylesData["sub1_hidden"] ? (
                          <VisibilityOffIcon
                            color="error"
                            sx={{ position: "absolute" }}
                          />
                        ) : (
                          <VisibilityIcon
                            color="success"
                            sx={{ position: "absolute" }}
                          />
                        )}
                      </Tooltip>
                    </Box>

                    <Box
                      sx={{
                        mx: 1,
                        display: "block",
                        flexDirection: "row",
                        flexFlow: "row wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ ml: 3, fontSize: "small" }}>
                        زبان زیرنویس اول:
                      </Typography>
                      <FormControl style={{ minWidth: 170, margin: "5px" }}>
                        <select
                          label="subtitleOneLanguage"
                          name="subtitleOneLanguage"
                          id="subtitleOneLanguage"
                          value={subtitleOneLanguage}
                          onChange={(e) => {
                            setSubtitleOneLanguage(e.target.value);
                            props.setFieldValue(
                              "subtitleOneLanguage",
                              e.target.value
                            );
                            const newValues = {
                              subtitleOneLanguage: e.target.value,
                            };
                            handleVideoInfo({
                              ...videoInfo,
                              ...newValues,
                            });
                            if (e.target.value.includes("-RTL"))
                              props.setFieldValue("subtitleOneRtl", true);
                          }}
                        >
                          <option autoFocus key={0} value="en">
                            English
                          </option>
                          <option autoFocus key={1} value="de">
                            German
                          </option>
                          <option autoFocus key={2} value="fr">
                            French
                          </option>
                          <option autoFocus key={3} value="it">
                            Italian
                          </option>
                          <option autoFocus key={4} value="tr">
                            Turkish
                          </option>
                        </select>
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="subtitleOneLanguage" />
                        </FormHelperText>
                      </FormControl>
                    </Box>
                    <Divider
                      variant="middle"
                      textAlign="left"
                      sx={{ my: 0.5 }}
                    ></Divider>
                    <Box sx={{ display: "flex" }}>
                      <Tooltip
                        title={`${
                          subtitleStylesData["sub2_hidden"] ? "پنهان" : "نمایش"
                        } (ویرایش در بخش تنظیمات زیرنویس)`}
                      >
                        {subtitleStylesData["sub1_hidden"] ? (
                          <VisibilityOffIcon
                            color="error"
                            sx={{ position: "absolute" }}
                          />
                        ) : (
                          <VisibilityIcon
                            color="success"
                            sx={{ position: "absolute" }}
                          />
                        )}
                      </Tooltip>
                    </Box>

                    <Box
                      sx={{ mx: 1, display: "block", alignSelf: "baseline" }}
                    >
                      <Box>
                        <Typography sx={{ ml: 3, fontSize: "small" }}>
                          زبان ترجمه(زیرنویس دوم):
                        </Typography>
                        <FormControl style={{ minWidth: 170, margin: "5px" }}>
                          <select
                            label="subtitleTwoLanguage"
                            name="subtitleTwoLanguage"
                            id="subtitleTwoLanguage"
                            value={subtitleTwoLanguage}
                            onChange={(e) => {
                              setSubtitleTwoLanguage(e.target.value);
                              props.setFieldValue(
                                "subtitleTwoLanguage",
                                e.target.value
                              );
                              if (e.target.value.includes("-RTL"))
                                props.setFieldValue("subtitleTwoRtl", true);
                            }}
                          >
                            <option autoFocus key={0} value="fr">
                              Persian
                            </option>
                          </select>
                          <FormHelperText
                            sx={{ color: "#f96767", textAlign: "center" }}
                          >
                            <ErrorMessage name="subtitleTwoLanguage" />
                          </FormHelperText>
                        </FormControl>
                      </Box>

                      <FormControlLabel
                        sc={{
                          display: "flex",
                          flexDirection: "colum",
                          color: "#ef657d",
                        }}
                        onChange={(e) => {
                          handleSubtitleTwoDisable(e.target.checked);
                          props.setFieldValue(
                            "subtitleTwoOff",
                            e.target.checked
                          );
                          if (e.target.checked)
                            props.setFieldValue("subtitleTwoFile", "");
                        }}
                        name="subtitleTwoOff"
                        control={
                          <Checkbox
                            checked={subtitleTwoDisable}
                            color="error"
                          />
                        }
                        label="بدون زیرنویس دوم"
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexFlow: "row wrap",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      ></Box>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box
                      sx={{
                        mx: 1,
                        display: "flex",
                        flexDirection: "row",
                        flexFlow: "row wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <FormControlLabel
                        sc={{
                          display: "flex",
                          flexDirection: "colum",
                          color: "#ef657d",
                        }}
                        onChange={(e) => {
                          handleFullscreenState(!fullscreenState);
                        }}
                        name="FullscreenState"
                        control={
                          <Checkbox
                            size="small"
                            checked={fullscreenState}
                            color="error"
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: "small" }}>
                            ادامه با نمایش تمام صفحه
                          </Typography>
                        }
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ mx: 2 }}
                        color="success"
                      >
                        تماشای فیلم و شروع یادگیری زبان
                      </Button>
                    </Box>
                    <FormHelperText
                      sx={{ color: "#f96767", textAlign: "center" }}
                    >
                      <ErrorMessage name="subtitleOneFile" />
                    </FormHelperText>
                    {subtitleTwoDisable ? null : (
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="subtitleTwoFile" />
                      </FormHelperText>
                    )}
                    <Divider sx={{ mt: 1 }} />
                    <Box
                      sx={{
                        m: 1,
                        display: "flex",
                        flexDirection: "row",
                        flexFlow: "row wrap",
                        alignItems: "center",
                        justifyContent: "space-around",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{ mx: 2 }}
                        size="small"
                        onClick={() => {
                          handleCloseButton();
                          if (fullscreenState && !handleFullScreen.active) {
                            handleFullScreen.enter();
                          }
                          setErrorSuffix(false);
                        }}
                        color="error"
                      >
                        بستن
                      </Button>
                      <Button
                        color="info"
                        size="small"
                        variant="contained"
                        onClick={() => {
                          if (userTypes.length > 0) {
                            handleMainCompareSubsOpen(true);
                            handleCloseSelectSubtitlesBox();
                          } else {
                            handleOpenSignInBox();
                            setTimeout(() => {
                              customToastify(
                                "error",
                                "لطفا ابتدا وارد شوید و سپس بر روی ایزار مقایسه کلیک کنید"
                              );
                            }, 500);
                          }
                        }}
                      >
                        مقایسه و انتخاب زیرنویس
                      </Button>
                    </Box>
                  </>
                )}
              </Box>

              {/* <SearchSubtitlesBox
                  formProps={props}
                  handleToggleSearchBox={handleToggleSearchBox}
                  subtitleSearchBox={subtitleSearchBox}
                /> */}
            </Form>
          </Paper>
        </DraggableComponent>
      )}
    </Formik>
    //     </DialogContent>
    //   </Dialog>
    // </React.Fragment>
  );
}

// const languagesList = {
//   ab: "Abkhazian",
//   aa: "Afar",
//   af: "Afrikaans",
//   ak: "Akan",
//   sq: "Albanian",
//   am: "Amharic",
//   ar: "Arabic",
//   an: "Aragonese",
//   hy: "Armenian",
//   as: "Assamese",
//   av: "Avaric",
//   ae: "Avestan",
//   ay: "Aymara",
//   az: "Azerbaijani",
//   bm: "Bambara",
//   ba: "Bashkir",
//   eu: "Basque",
//   be: "Belarusian",
//   bn: "Bengali",
//   bh: "Bihari languages",
//   bi: "Bislama",
//   bs: "Bosnian",
//   br: "Breton",
//   bg: "Bulgarian",
//   my: "Burmese",
//   ca: "Catalan, Valencian",
//   km: "Central Khmer",
//   ch: "Chamorro",
//   ce: "Chechen",
//   ny: "Chichewa, Chewa, Nyanja",
//   zh: "Chinese",
//   cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
//   cv: "Chuvash",
//   kw: "Cornish",
//   co: "Corsican",
//   cr: "Cree",
//   hr: "Croatian",
//   cs: "Czech",
//   da: "Danish",
//   dv: "Divehi, Dhivehi, Maldivian",
//   nl: "Dutch, Flemish",
//   dz: "Dzongkha",
//   en: "English",
//   eo: "Esperanto",
//   et: "Estonian",
//   ee: "Ewe",
//   fo: "Faroese",
//   fj: "Fijian",
//   fi: "Finnish",
//   fr: "French",
//   ff: "Fulah",
//   gd: "Gaelic, Scottish Gaelic",
//   gl: "Galician",
//   lg: "Ganda",
//   ka: "Georgian",
//   de: "German",
//   ki: "Gikuyu, Kikuyu",
//   el: "Greek (Modern)",
//   kl: "Greenlandic, Kalaallisut",
//   gn: "Guarani",
//   gu: "Gujarati",
//   ht: "Haitian, Haitian Creole",
//   ha: "Hausa",
//   he: "Hebrew",
//   hz: "Herero",
//   hi: "Hindi",
//   ho: "Hiri Motu",
//   hu: "Hungarian",
//   is: "Icelandic",
//   io: "Ido",
//   ig: "Igbo",
//   id: "Indonesian",
//   ia: "Interlingua (International Auxiliary Language Association)",
//   ie: "Interlingue",
//   iu: "Inuktitut",
//   ik: "Inupiaq",
//   ga: "Irish",
//   it: "Italian",
//   ja: "Japanese",
//   jv: "Javanese",
//   kn: "Kannada",
//   kr: "Kanuri",
//   ks: "Kashmiri",
//   kk: "Kazakh",
//   rw: "Kinyarwanda",
//   kv: "Komi",
//   kg: "Kongo",
//   ko: "Korean",
//   kj: "Kwanyama, Kuanyama",
//   ku: "Kurdish",
//   ky: "Kyrgyz",
//   lo: "Lao",
//   la: "Latin",
//   lv: "Latvian",
//   lb: "Letzeburgesch, Luxembourgish",
//   li: "Limburgish, Limburgan, Limburger",
//   ln: "Lingala",
//   lt: "Lithuanian",
//   lu: "Luba-Katanga",
//   mk: "Macedonian",
//   mg: "Malagasy",
//   ms: "Malay",
//   ml: "Malayalam",
//   mt: "Maltese",
//   gv: "Manx",
//   mi: "Maori",
//   mr: "Marathi",
//   mh: "Marshallese",
//   ro: "Moldovan, Moldavian, Romanian",
//   mn: "Mongolian",
//   na: "Nauru",
//   nv: "Navajo, Navaho",
//   nd: "Northern Ndebele",
//   ng: "Ndonga",
//   ne: "Nepali",
//   se: "Northern Sami",
//   no: "Norwegian",
//   nb: "Norwegian Bokmål",
//   nn: "Norwegian Nynorsk",
//   ii: "Nuosu, Sichuan Yi",
//   oc: "Occitan (post 1500)",
//   oj: "Ojibwa",
//   or: "Oriya",
//   om: "Oromo",
//   os: "Ossetian, Ossetic",
//   pi: "Pali",
//   pa: "Panjabi, Punjabi",
//   ps: "Pashto, Pushto",
//   fa: "Persian",
//   pl: "Polish",
//   pt: "Portuguese",
//   qu: "Quechua",
//   rm: "Romansh",
//   rn: "Rundi",
//   ru: "Russian",
//   sm: "Samoan",
//   sg: "Sango",
//   sa: "Sanskrit",
//   sc: "Sardinian",
//   sr: "Serbian",
//   sn: "Shona",
//   sd: "Sindhi",
//   si: "Sinhala, Sinhalese",
//   sk: "Slovak",
//   sl: "Slovenian",
//   so: "Somali",
//   st: "Sotho, Southern",
//   nr: "South Ndebele",
//   es: "Spanish, Castilian",
//   su: "Sundanese",
//   sw: "Swahili",
//   ss: "Swati",
//   sv: "Swedish",
//   tl: "Tagalog",
//   ty: "Tahitian",
//   tg: "Tajik",
//   ta: "Tamil",
//   tt: "Tatar",
//   te: "Telugu",
//   th: "Thai",
//   bo: "Tibetan",
//   ti: "Tigrinya",
//   to: "Tonga (Tonga Islands)",
//   ts: "Tsonga",
//   tn: "Tswana",
//   tr: "Turkish",
//   tk: "Turkmen",
//   tw: "Twi",
//   ug: "Uighur, Uyghur",
//   uk: "Ukrainian",
//   ur: "Urdu",
//   uz: "Uzbek",
//   ve: "Venda",
//   vi: "Vietnamese",
//   vo: "Volap_k",
//   wa: "Walloon",
//   cy: "Welsh",
//   fy: "Western Frisian",
//   wo: "Wolof",
//   xh: "Xhosa",
//   yi: "Yiddish",
//   yo: "Yoruba",
//   za: "Zhuang, Chuang",
//   zu: "Zulu",
// };
